import MicRecorder from 'mic-recorder-to-mp3'

export class AudioRecorder {
  private recorder!: any

  constructor () {
    this.recorder = new MicRecorder({
      bitRate: 128
    })
  }

  async record () {
    // Start recording. Browser will request permission to use your microphone.
    await this.recorder.start()
  }

  async stop () {
    // Once you are done singing your best song, stop and get the mp3.
    const [buffer, blob] = await this.recorder.stop().getMp3()
    const file = new File(buffer, 'recording.mp3', {
      type: blob.type,
      lastModified: Date.now()
    })

    if (file.size < 7680) { // at least 20 frames
      return false
    }

    return file

    // DO NOT REMOVE OR SOUND QUALITY WILL SUCK FOR SOME REASON!
    const player = new Audio(URL.createObjectURL(file))
    // player.play()
  }
}
